// ----------------------------------------------------------------------------
// Component: Press Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Scrollbar, A11y } from 'swiper';

import './_stretch-range.scss';


// -------------------------------------
// Variables
// -------------------------------------

$(function() {
    $(".carousel--press-block").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("press-block-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.find(".swiper-scrollbar").addClass("press-block-swiper-scrollbar-" + index);

        var swiper = new Swiper(".press-block-instance-" + index, {
            // Optional parameters
            modules: [Scrollbar, A11y],
            slidesPerView: 2,
            spaceBetween: 20,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 40
                }
            },

            scrollbar: {
                el: ".press-block-swiper-scrollbar-" + index,
                draggable: true,
            },
        });
    });
});
